import React from "react";
import maintenanceImage from "../../../assets/images/DPI-maintenance.png";

const styles = {
    wrapper: {
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000"
    },
    image: {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain"
    }
};

const MaintenancePage = () => (
    <div style={styles.wrapper}>
        <img src={maintenanceImage} alt="System under maintenance" style={styles.image} />
    </div>
);

export default MaintenancePage;
